export default class NewsletterModal {
	constructor() {
		document.addEventListener('bless', (e) => {
			const container = e.target;
			this.init(container);
		});
	}

	init(container) {
		this.dialog = container.querySelector('[data-newsletter-modal]');

		if (!this.dialog) {
			return;
		}

		// Elements
		this.form = this.dialog.querySelector('form');
		this.feedback = this.dialog.querySelector('[data-form-feedback]');
		this.openButtons = container.querySelectorAll('[data-newsletter-modal-open]');
		this.closeButton = container.querySelector('[data-newsletter-modal-close]');
		this.honeypotFields = this.dialog.querySelectorAll('[data-rr]');

		this.interacted =
			localStorage?.getItem('newsletter') === 'subscribed' || localStorage?.getItem('newsletter') === 'closed';

		// Open the modal
		if (!this.interacted) {
			const delay = parseInt(this.dialog.dataset.delay, 10);
			setTimeout(
				() => {
					this.open();
				},
				isNaN(delay) ? 2000 : delay
			);
		}

		this.isSubmitting = false;

		this.handleFormSubmit = this.submit.bind(this);
		this.handleCloseClick = this.close.bind(this);

		// Honey Pot
		this.honeypotFields.forEach((field) => {
			this.handleHoneyPotField(field);
		});

		this.form.addEventListener('submit', this.handleFormSubmit);
		this.closeButton.addEventListener('click', this.handleCloseClick);

		this.dialog.addEventListener('click', (e) => {
			if (e.target === this.dialog) {
				e.preventDefault();
				this.close();
			}
		});

		this.openButtons.forEach((button) => {
			button.addEventListener('click', (e) => {
				this.open();
			});
		});
	}

	handleHoneyPotField(field) {
		field.removeAttribute('required');
		field.tabIndex = -1;
		field.classList.add('rr');
	}

	open() {
		this.dialog.showModal();
		this.dialog.focus();
	}

	close() {
		this.dialog.close();
		this.reset();
		this.form.removeEventListener('submit', this.handleFormSubmit);
		this.closeButton.removeEventListener('click', this.handleCloseClick);
		localStorage.setItem('newsletter', 'closed');
	}

	submit(e) {
		e.preventDefault();

		if (this.isSubmitting) {
			return; // Prevent multiple submit requests
		}

		this.isSubmitting = true;

		fetch(this.form.action, {
			method: 'POST',
			body: new FormData(this.form),
		})
			.then((response) => response.json())
			.then((data) => this.displaySuccess(data))
			.catch((error) => this.displayFailure(error))
			.finally(() => (this.isSubmitting = false));
	}

	displaySuccess(data) {
		if (!data.success) {
			this.displayFailure(data);
			return;
		}

		localStorage.setItem('newsletter', 'subscribed');

		this.form.classList.add('is-hidden');
		this.feedback.textContent = data.data.message;
		this.feedback.style.color = '#000000';
		this.feedback.classList.add('is-active');
	}

	displayFailure(data) {
		this.feedback.textContent = data.data.message;
		this.feedback.style.color = '#C80000';
		this.feedback.classList.add('is-active');
	}

	reset() {
		this.feedback.classList.remove('is-active');
		this.form.classList.remove('is-hidden');

		// Clear visible input fields
		this.form.querySelectorAll('input[type="text"], input[type="email"]').forEach((field) => {
			field.value = '';
		});
	}
}
